var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 16.7988C2.375 18.0363 3.44375 19.0488 4.75 19.0488H14.25C15.5562 19.0488 16.625 18.0363 16.625 16.7988L17.8125 3.29883H1.1875L2.375 16.7988ZM3.5625 4.42383H15.4375L14.25 16.7988H4.75L3.5625 4.42383ZM0 1.04883V3.29883H19V1.04883H0Z",
    fill: "#FDFDFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08897 16.438C8.66014 15.9679 8.71162 15.26 9.20397 14.8569L12.8119 11.9031C13.3042 11.5 14.051 11.5543 14.4798 12.0244C14.9086 12.4945 14.8571 13.2023 14.3648 13.6054L10.7569 16.5593C10.2646 16.9624 9.5178 16.9081 9.08897 16.438Z",
    fill: "#FDFDFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99088 16.7998C6.37028 17.0007 5.68774 16.6661 5.46639 16.0525L3.9638 11.8873C3.74245 11.2737 4.0661 10.6134 4.68669 10.4125C5.30729 10.2115 5.98982 10.5461 6.21118 11.1597L7.71376 15.3249C7.93512 15.9385 7.61147 16.5988 6.99088 16.7998Z",
    fill: "#FDFDFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8643 13.6138C10.4258 14.0758 9.67721 14.1156 9.1923 13.7025L5.65001 10.6852C5.16509 10.2722 5.12746 9.5628 5.56596 9.10077C6.00445 8.63875 6.75302 8.59904 7.23793 9.01208L10.7802 12.0294C11.2651 12.4424 11.3028 13.1518 10.8643 13.6138Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/prescription.682f1ce04463787f6b1f4e08c65b6a74.svg";
export { ForwardRef as ReactComponent };